import React from 'react';

const MenuAdminLayout = ({ title, description, children }) => {
  return (
    <div>
      <h3 className="text-3xl font-bold mb-3">{title}</h3>
      <p className="text-flexi-grey">{description}</p>
      {children}
    </div>
  );
};

export default MenuAdminLayout;